import React, { useRef, useEffect } from 'react';
import { Accordion } from 'cd-eft/components/common/Accordion';
import { formatDate } from 'cd-eft/utils/formatDate';
import { timeSince } from 'cd-eft/utils/timeSince';
import { Form, FormText, FormGroup, Label, Col, Input, Table } from 'reactstrap';
import { observer } from 'mobx-react';
import { ProjectCommentsVM } from './ProjectCommentsVM';
import { ActionsMenu } from 'cd-eft/components/Design/common/ActionsMenu';
import { Popup } from 'cd-eft/components/common/Popup';
import './ProjectComments.scss';

import stores from 'cd-eft/models/Stores';
const libraryStore = stores.AppStore.projectsLibraryStore;

const ProjectCommentsComponent = (props) => {
  const vm = useRef(new ProjectCommentsVM(props)).current;
    useEffect(() => {
      if(props.updateCallback){
        props.updateCallback();
      }
    }, [ props.allProjectandDesignComments, vm.deleteDataLength]);

  return (
    <>
      {(props.listAllComments ? props.allCommentsData : libraryStore.projectComments) && (
        <div className="contanier">
          <Accordion 
            className="p-0 accordion-wrapper" 
            headers={['Project Comments ']}
            actionButton={ <ActionsMenu i={'project-comments'} item="item" elementActions={vm.elementActions}>Action</ActionsMenu> }
          >
            <div className="sub-container">
              <div className="comments-container">
                {(props.listAllComments ? props.allCommentsData : libraryStore.projectComments).length === 0 && !vm.addFormVisible && (
                  <div className="no-comment">
                    <p>No Project Comment</p>
                  </div>
                )}
                {vm.addFormVisible && (
                  /* Create project comments form */
                  <Form fluid={+true}>
                    <FormGroup>
                      <Col>
                        <Label for="createdBy">
                          <div className="info">
                            <div className="name">
                              <strong>{vm.logginUser? vm.logginUser.split('@')[0].replace('.', ' '): ''}</strong>
                            </div>
                            <div className="date">{formatDate(Date.now())}</div>
                          </div>
                        </Label>
                      </Col>
                      <Col>
                        <Input
                          name="projectComment"
                          value={vm.newProjectComment.projectComment}
                          placeholder="add comment"
                          type="textarea"
                          autoFocus
                          onChange={vm.handleInput}
                          rows={vm.rowHeight}
                        />
                      </Col>
                    </FormGroup>
                  </Form>
                )}
                {vm.addFormVisible && (
                  <div className="d-flex justify-content-end usa-buttons">
                    <button className="usa-button usa-button--outline" onClick={vm.cancelProjectComment}>
                      Close
                    </button>
                    <button className="usa-button" onClick={vm.createProjectComments} disabled={vm.isSaving}>
                      Save
                    </button>
                  </div>
                )}

                {(props.listAllComments ? props.allCommentsData : libraryStore.projectComments) &&
                  (props.listAllComments ? props.allCommentsData : libraryStore.projectComments).map((comment, i) => {
                    return (
                      <div className="comment-wrapper " key={'key comment -' + i}>
                        {/* Project comment ready only */}
                        {vm.readOnlyForm && (
                          <Form fluid={+true}>
                            <FormGroup>
                              <Col>
                                <Label for="createdBy">
                                  <div className="info">
                                    <div className="name">
                                      <strong>{comment.commentAuthor}</strong>
                                    </div>
                                    <div className="">
                                      {`${comment.lastChangeDateUtc && timeSince(parseInt(comment.lastChangeDateUtc))
                                        }, ${formatDate(comment.lastChangeDateUtc)}`}
                                    </div>
                                    {comment.editStatus === 'update' && (
                                      <div>{`\u00A0- Edited By ${comment.lastChangedBy}`}</div>
                                    )}
                                  </div>
                                </Label>
                              </Col>
                              <FormText
                                className="form-text"
                                readOnly
                                id={comment.projectCommentId}
                                value={comment.projectComment}
                              >
                                {comment.projectComment}
                              </FormText>
                            </FormGroup>
                          </Form>
                        )}
                        {/* Edit project comments Form */}
                        {vm.editFormVisible && (
                          <Form fluid={+true}>
                            <FormGroup>
                              <Col>
                                <Label for="createdBy">
                                  <div className="info">
                                    {vm.editCheckboxes && (
                                      <div className="checkbox">
                                        <Input
                                          id={comment.projectCommentId}
                                          name={localStorage['username']}
                                          type="checkbox"
                                          onChange={vm.handleCheckBox}
                                          checked={vm.targetId == comment.projectCommentId}
                                        />
                                      </div>
                                    )}

                                    {vm.deleteCheckboxes && (
                                      <div className="checkbox">
                                        <Input
                                          id={comment.projectCommentId}
                                          name={localStorage['username']}
                                          value={comment.projectCommentId}
                                          type="checkbox"
                                          onChange={(e)=>vm.handleDeleteCheckBox(e, props.allCommentsData)}
                                        />
                                      </div>
                                    )}

                                    <div className="name">
                                      <strong>{comment.commentAuthor}</strong>
                                    </div>
                                    <div className="edited-by">
                                      {`${comment.lastChangeDateUtc && timeSince(comment.lastChangeDateUtc)
                                        }, ${formatDate(comment.lastChangeDateUtc)}`}
                                    </div>
                                    {comment.editStatus === 'update' && (
                                      <div>{`\u00A0- Edited By ${comment.lastChangedBy}`}</div>
                                    )}
                                  </div>
                                </Label>
                              </Col>

                              {!(vm.targetId == comment.projectCommentId) && (
                                <FormText
                                  className="form-text"
                                  readOnly
                                  id={comment.projectCommentId}
                                  value={comment.projectComment}
                                >
                                  {comment.projectComment}
                                </FormText>
                              )}
                              {(vm.targetId == comment.projectCommentId) && (
                                <div className="edit-input">
                                  <Input
                                    id={comment.commentTypeId}
                                    name="comment"
                                    defaultValue={comment.projectComment}
                                    placeholder="add comment"
                                    type="textarea"
                                    readOnly={!(vm.targetId == comment.projectCommentId)}
                                    onChange={vm.handleInputChange}
                                  />
                                </div>
                              )}
                            </FormGroup>
                          </Form>
                        )}
                        {(vm.editFormBtnVisible && (vm.targetId == comment.projectCommentId)) && (
                          <div className="d-flex justify-content-end usa-buttons">
                            <button className="usa-button usa-button--outline" onClick={vm.cancelEditComment}>
                              Close
                            </button>
                            <button className="usa-button" onClick={()=>vm.editProjectComment(props.allCommentsData)}>
                              Save
                            </button>
                          </div>
                        )}
                      </div>
                    );
                  })}
              </div>

              {vm.deletePopup && (

                  <Popup
                    trigger={vm.deletePopup}
                    setTrigger={vm.toggleDeletePopup}
                    title="Delete Comment?"
                    handleCancel={vm.cancelProjectComment}
                    cancelText="Close"
                    handleOK={vm.deleteProjectComments}
                    okText="Delete"
                  >
                    {vm.deleteProjectcommentsData.length === 1
                      ? <p>Are you sure you want to delete this comment?</p>
                      : <p>Are you sure you want to delete these comments?</p>
                    }
                    {vm.deleteProjectcommentsData &&
                      vm.deleteProjectcommentsData.map((deleteComment, i) => {
                        return (
                          <div
                            key={'key delete -' + i}
                            className={`${vm.deleteProjectcommentsData.length === 1
                              ? 'single-comment-wrrapper'
                              : 'delete-comment-wrraper'
                              } `}
                          >
                            <Table borderless>
                              <tbody>
                                <tr>
                                  <th scope="row">Author</th>
                                  <td className="name capitalize">{deleteComment.commentAuthor}</td>
                                </tr>
                                <tr>
                                  <th scope="row">Created</th>
                                  <td>{formatDate(deleteComment.creationDateUtc)}</td>
                                </tr>

                                {deleteComment.prevEditStatus === 'update' &&
                                  <tr>
                                    <th scope="row">Edited by</th>
                                    <td className="name capitalize">{deleteComment.lastChangedBy}</td>
                                  </tr>
                                }
                                {deleteComment.prevEditStatus === 'update' &&
                                  <tr>
                                    <th scope="row">Edited on</th>
                                    <td>{formatDate(deleteComment.lastChangeDateUtc)}</td>
                                  </tr>
                                }
                                <tr>
                                  <th scope="row">Comment</th>
                                  <td>{deleteComment.projectComment}</td>
                                </tr>
                              </tbody>
                            </Table>
                          </div>
                        );
                      })}
                  </Popup>

              )}
              {(vm.cancelButton &&
                <div className="d-flex justify-content-end usa-buttons">
                  <button className="usa-button usa-button--outline" onClick={vm.cancelProjectComment}>
                    Close
                  </button>
                </div>
              )}
              {vm.deleteFormBtnVisible && !vm.deleteDataLength && (
                <div className="d-flex justify-content-end usa-buttons">
                  <button className="usa-button usa-button--outline" onClick={vm.cancelProjectComment}>
                    Close
                  </button>
                  <button className="usa-button" onClick={vm.toggleDeletePopup}>
                    Delete
                  </button>
                </div>
              )}
            </div>
          </Accordion>
        </div>
      )}
    </>
  );
};
export const ProjectComments = observer(ProjectCommentsComponent);
